import { CommonModule } from '@angular/common';
import { ProjectRoutingModule } from './projects-routing.module';
import { NgModule } from '@angular/core';
import { ProjectListComponent } from './list/project-list.component';
import { ProjectDetailComponent } from './detail/project-detail.component';
import { ProjectService } from './project.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectFeedService } from './project-feed.service';
import { CreateProjectModal } from './create-projekt-modal/create-project-modal';
import { ProjectStructureTreeComponent } from './structure-tree/structure-tree.component';
import { ClientProjectsTreeComponent } from '../shared/client-projects-tree/client-projects-tree.component';
import { ClientProjectsTreeItemComponent } from '../shared/client-projects-tree/client-projects-tree-item.component';
import { SharedModule } from '../shared/shared/shared.module';
import { ProjectDetailMainComponent } from './detail/project-detail-main/project-detail-main.component';
import { ProjectDetailObjectsComponent } from './detail/project-detail-objects/project-detail-objects.component';
import { ProjectDetailWidgetsComponent } from './detail/project-detail-widgets/project-detail-widgets.component';
import { ProjectListItemComponent } from './list/project-list-item/project-list-item.component';
import { ProjectDetailWidgetDetailComponent } from './detail/project-detail-widget-detail/project-detail-widget-detail.component';
import { EditObjectModalComponent } from './edit-object-modal/edit-object-modal.component';
import { ProjectListFilterComponent } from './list/project-list-filter/project-list-filter.component';
import { ProjectDetailFeedComponent } from './detail/project-detail-feed/project-detail-feed.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChangeStatusModalComponent } from './change-status-modal/change-status-modal.component';
import { StatusFilterComponent } from './list/status-filter/status-filter.component';
import { ImportObjectsModalComponent } from './detail/project-detail-objects/import-objects-modal/import-objects-modal.component';
import { ClarityModule } from '@clr/angular';
import { ProjectDetailApiComponent } from './detail/project-detail-api/project-detail-api.component';

@NgModule({
  declarations: [
    ProjectListComponent,
    ProjectDetailComponent,
    CreateProjectModal,
    ProjectStructureTreeComponent,
    ClientProjectsTreeComponent,
    ClientProjectsTreeItemComponent,
    ProjectDetailMainComponent,
    ProjectDetailObjectsComponent,
    ProjectDetailWidgetsComponent,
    ProjectListItemComponent,
    ProjectDetailWidgetDetailComponent,
    EditObjectModalComponent,
    ProjectListFilterComponent,
    ProjectDetailFeedComponent,
    ChangeStatusModalComponent,
    StatusFilterComponent,
    ImportObjectsModalComponent,
    ProjectDetailApiComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CommonModule,
    SharedModule,
    ClarityModule,
    ProjectRoutingModule
  ],
  providers: [
    ProjectService,
    ProjectFeedService
  ],
  entryComponents: [
    ChangeStatusModalComponent,
    CreateProjectModal,
    EditObjectModalComponent,
    ImportObjectsModalComponent
  ],
  bootstrap: []
})
export class ProjectsModule {
}



// WEBPACK FOOTER //
// ./src/app/projects/projects.module.ts